/**
 * Client-side routing helper to navigate without page refresh
 * @param href - The URL to navigate to
 */
export const navigateTo = (href: string) => {
    setTimeout(() => {
        if (href.startsWith('/')) {
            // Internal route - use pushState for SPA navigation
            window.history.pushState({}, '', href);
            // Trigger a popstate event to update the UI
            window.dispatchEvent(new PopStateEvent('popstate'));
        } else {
            // External URL - use normal navigation
            window.location.href = href;
        }
    }, 10);
};

/**
 * Handle click events for anchor tags to prevent default and use SPA routing
 * @param e - Click event
 * @param href - The URL to navigate to
 */
export const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    e.stopPropagation();

    let target = e.target as HTMLElement;
    while (target && target.tagName !== 'A') {
        target = target.parentElement as HTMLElement;
    }
    console.log(target);
    navigateTo(target.getAttribute('href') ?? '/');
};